import React, { useState } from 'react';
import { Card, Row, Col, Form, Input, Button, Switch, Space, Typography, Checkbox, Avatar, Flex } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import HeadingSubHeading from '../../../../components/ViewHeading/HeadingSubHeading';
import './../index.scss';

const { Title, Text } = Typography;

const IDCard = () => {
    interface Field {
        name: string;
        type: string;
    }

    const initialFields: Field[] = [
        { name: 'Job Title', type: 'text' },
        { name: 'Employee Number', type: 'text' },
        { name: 'Department', type: 'text' },
        { name: 'Location', type: 'text' },
        { name: 'Blood Group', type: 'text' },
    ];

    const [fields, setFields] = useState<Field[]>(initialFields);
    const [isDigital, setIsDigital] = useState(false);

    const onDragEnd = (result: any) => {
        const { source, destination } = result;
        if (!destination) return;

        const reorderedFields = Array.from(fields);
        const [removed] = reorderedFields.splice(source.index, 1);
        reorderedFields.splice(destination.index, 0, removed);
        setFields(reorderedFields);
    };

    const Filed = (name, key) => {
        return <div className='checkbox-field'>
            <Checkbox key={key} >{name}</Checkbox>
        </div>
    }

    return (
        <Card title={
            <HeadingSubHeading
                titleProps={{ level: 5 }}
                title={'ID Card Settings'}
                subTitle="Here you can chnage what details you want to display on your digital ID card." />
        }>
            <Row gutter={16}>
                <Col span={12}>
                    <div className='id_box-view'>
                        <Flex justify='center' gap={30}>
                            <Card style={{ width: '100%' }}>
                                <Space direction='vertical' align='center' style={{ width: '100%' }}>
                                    <Avatar src={'https://via.placeholder.com/150'} size={100} />
                                    <div style={{ textAlign: 'center' }}>
                                        <Title level={5} style={{ marginBottom: 0 }}>Terry Westervelt</Title>
                                        <Text type='secondary'>Business & Operations Head</Text><br />
                                        <Text type='secondary'>AG-00015</Text>
                                    </div>
                                </Space>
                                <Space direction='vertical' size={[20, 0]}>
                                    <Space direction='horizontal'>
                                        <Text type='secondary'>Department : </Text>
                                        <Text>Business Developement</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text type='secondary'>Location : </Text>
                                        <Text>Hyedrabad</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text type='secondary'>Blood Group : </Text>
                                        <Text>A+</Text>
                                    </Space>
                                </Space>
                            </Card>
                            <Card style={{ width: '100%' }}>
                                <Avatar src={'https://via.placeholder.com/150'} size={100} />
                                <div>
                                    <h3>Terry Westervelt</h3>
                                    <p>Business & Operations Head</p>
                                    <p>AG-00015</p>
                                </div>
                                <div>
                                    <h4>Fields:</h4>
                                </div>
                            </Card>
                        </Flex>
                    </div>
                </Col>

                <Col span={12}>
                    <Space size={[0, 20]} direction='vertical' style={{ width: '100%' }}>
                        <Space direction='horizontal'>
                            <Switch size='default' />Digital ID Card enabled
                        </Space>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Title level={5}>Fields to show on card </Title>
                            </Col>
                            <Col span={12}>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Text>Front Side</Text>
                                    </Col>
                                    <Col span={24}>
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            <Droppable droppableId="droppable">
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        <Row gutter={[16, 16]}>
                                                            {fields.map((field, index) => (
                                                                <Col span={24}>
                                                                    <Draggable key={field.name} draggableId={field.name} index={index}>
                                                                        {(provided) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                style={{ ...provided.draggableProps.style }}
                                                                            >
                                                                                {Filed(field.name, index)}
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                </Col>
                                                            ))}
                                                            {provided.placeholder}
                                                        </Row>
                                                    </div>)}
                                            </Droppable>
                                        </DragDropContext>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Text>Back Side </Text>
                                    </Col>
                                    <DragDropContext onDragEnd={onDragEnd}>
                                        <Droppable droppableId="droppable-1">
                                            {(provided) => (
                                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                                    <Row gutter={[16, 16]}>
                                                        {fields.map((field, index) => (
                                                            <Col span={24}>
                                                                <Draggable key={field.name} draggableId={field.name} index={index}>
                                                                    {(provided) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            style={{ ...provided.draggableProps.style }}
                                                                        >
                                                                            {Filed(field.name, index)}
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            </Col>
                                                        ))}
                                                        {provided.placeholder}
                                                    </Row>
                                                </div>)}
                                        </Droppable>
                                    </DragDropContext>
                                </Row>
                            </Col>
                        </Row>
                    </Space>
                </Col>
            </Row>
        </Card >
    );
}

export default IDCard;